import {
  Card,
  Table,
  TableBody,
  TableHeader,
  TableHeaderCell,
  TableRow,
  Body1Strong,
} from '@fluentui/react-components';
import { ITableColumnSizingState, TTableRow } from '@shared/types';
import AccessLogsTableRow from './AccessLogsTableRow';
import { TAccessLog } from '../../types/accessLogs.types';
import { useItemTableStyles } from '../../../items';

type TProps = {
  rows: TTableRow<TAccessLog>[];
  columnSizing: ITableColumnSizingState;
};

const AccessLogsTable = ({ rows, columnSizing }: TProps) => {
  const classes = useItemTableStyles();

  return (
    <Card className={classes.card}>
      <Table className={classes.table} {...columnSizing?.getTableProps?.()}>
        <TableHeader>
          <TableRow>
            <TableHeaderCell {...columnSizing.getTableHeaderCellProps('description')}>
              <Body1Strong>Description</Body1Strong>
            </TableHeaderCell>
            <TableHeaderCell {...columnSizing.getTableHeaderCellProps('date')}>
              <Body1Strong>Date</Body1Strong>
            </TableHeaderCell>
            <TableHeaderCell {...columnSizing.getTableHeaderCellProps('initiator')}>
              <Body1Strong>Initiator</Body1Strong>
            </TableHeaderCell>
          </TableRow>
        </TableHeader>

        <TableBody className={classes.tableBody}>
          {rows.map((row) => (
            <AccessLogsTableRow {...row} columnSizing={columnSizing} key={row.key} />
          ))}
        </TableBody>
      </Table>
    </Card>
  );
};

export default AccessLogsTable;
